import { WAITLIST_URL } from "./constants";

type CtaButtonProps = {
  label: string;
  /** "dark" = botão preto (fundo claro) · "light" = botão branco (fundo escuro) */
  variant?: "dark" | "light";
  /** aplica o micro-glitch de hover (usar só no CTA principal) */
  main?: boolean;
  full?: boolean;
  className?: string;
  /** se definido, o botão rola suave até essa seção em vez de abrir o link */
  scrollTo?: string;
  /** link de destino; padrão = lista de espera (o desafio dessa turma já começou) */
  href?: string;
};

/** por padrão abre a lista de espera em nova aba; com `scrollTo`, rola até a âncora */
const CtaButton = ({
  label,
  variant = "dark",
  main = false,
  full = false,
  className = "",
  scrollTo,
  href = WAITLIST_URL,
}: CtaButtonProps) => {
  const classes = [
    "inline-flex items-center justify-center whitespace-nowrap rounded-full px-8 py-4 text-base font-bold tracking-[-0.02em]",
    variant === "dark"
      ? "bg-black text-white hover:bg-black/85"
      : "bg-white text-black hover:bg-white/90",
    main ? "e21-cta-main" : "transition-transform hover:scale-[1.02]",
    full ? "w-full" : "",
    className,
  ].join(" ");

  if (scrollTo) {
    return (
      <button
        type="button"
        className={classes}
        onClick={() =>
          document
            .getElementById(scrollTo)
            ?.scrollIntoView({ behavior: "smooth" })
        }
      >
        {label}
      </button>
    );
  }

  return (
    <a href={href} target="_blank" rel="noopener" className={classes}>
      {label}
    </a>
  );
};

export default CtaButton;
